/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormDateTimeField, {
  FormDateTimeFieldProps
} from '../../../../client/js/components/form/fields/FormDatetimeField'

function RenewalDateField (props: FormDateTimeFieldProps) {
  const { name = 'renewalDate', ...others } = props
  const intl = useIntl()
  return (
    <FormDateTimeField
      disabled
      label={intl.formatMessage({
        id: 'renewal_date',
        defaultMessage: 'Date de renouvellement'
      })}
      name={name}
      {...others}
    />
  )
}

export default RenewalDateField
